{
  "files": "Files",
  "request": "Request",
  "all": "All",
  "admin": "Admin",
  "buyer": "Buyer",
  "seller": "Seller",
  "loading": "Loading PDF",
  "browse-files": "Browse Files",
  "drag-or-drop": "Drag and Drop file here or",
  "documents": "Documents",
  "modal-rename-title": "Rename",
  "modal-rename-subtitle": "Please enter a new name for the document",
  "modal-rename-regex": "The name can only use letters, numbers and hyphen",
  "modal-rename-cancel": "Cancel",
  "modal-delete-title-span": "delete",
  "success-updating": "Document updated",
  "user": "User",
  "modal-delete-required-doc-title-prefix": "This document is already associated a file, Are you sure you want to",
  "modal-delete-required-doc-title-suffix": "it from the list of required documents?",
  "pending": "Pending",
  "done": "Done",
  "invalid": "Invalid",
  "status": "Status",
  "payment": "Payment",
  "reference": "Reference",
  "routing": "Routing",
  "settlement-agency": "Settlement Agency",
  "unactive-link": "This upload link is no longer active.",
  "check-with-agent": "Please check with your title agent to see if",
  "theres-new-link": "there’s a new link available.",
  "any-question-or": "Any questions or concerns you can contact your title",
  "agent-or": "agent or the agency directly.",
  "close-window": "Close this window",
  "you-can-check": "You can check our",
  "privacy-notice": "privacy notice",
  "for-more-informtion": "for more informtion.",
  "send-files": "Send Files",
  "all-documents-have-been": "All your documents have been sent. All your info and documents are safely protected and will only be used by our title agent assigned to your order.",
  "Thanks-for-trusting": "Thanks for trusting us",
  "link-copied": "Link Copied to the Clipboard",
  "there-not-docs": "No required documents yet",
  "are-you-sure": "Are you sure about unsubscribing?",
  "if-you-unsubscribe": " If you unsubscribe now, you will stop receiving your order updates and all information related.",
  "subscribe-again": "If you want to subscribe again, please contact",
  "clsing-agent": " your closing agent.",
  "unsubscribed": "Unsubscribed Successfully!",
  "we-miss-you": "We miss you already. Thank you for being part of our project, we hope to see you soon.",
  "yes-unsubscribe": "Yes, Unsubscribe me",
  "document-templates": "Document Templates",
  "select-template": "Select a Template to Edit",
  "list-templates": "List of templates",
  "field-info": "Field Info",
  "images": "Images",
  "copy-text": "Click to Copy Text",
  "copy-image": "Click to Copy Image",
  "template": "Template",
  "tag-copied": "Tag copied",
  "image-copied": "Image Copied",
  "signatures": "Signatures",
  "define-dates": "Define the deadlines for uploading files",
  "document-request-sended": "Document requests were successfully sent",
  "document-request-continue": "Continue",
  "document-request-single-use": "This link can be used once; if you need another, request a new one.",
  "document-request-not-yet": "This upload link isn't available yet.",
  "document-request-used": "This link was already used or has expired. Request a new one.",
  "document-request-invalid": "This link is invalid or expired.",
  "document-request-expired": "This upload session has expired. Request a new link.",
  "send-doc": "Send Document to Sign",
  "archive": "Archive",
  "upload-required-documents": "Uploading Required Documents",
  "provide-following-documents": "Please, Provide the following documents listed here to continue the process.",
  "drag-drop-select": "Drag and drop some files here, or click here to select files",
  "error-uplading": "An unexpected error occurred trying to upload the files",
  "upload-success": "All documents were uploaded successfully",
  "document-ron": "Document for RON",
  "edit-document": "Edit Document",
  "new-template": "Add New Template",
  "back-to-templates": "Back to templates",
  "templates-empty": "No document templates yet.",
  "templates-error": "Unable to load document templates.",
  "template-options-loading": "Loading template options...",
  "template-options-error": "Unable to load template options.",
  "delete-template": "Delete template",
  "narrow-results": "Showing the first {{count}} matches. Type more to narrow the list.",
  "property-required": "Property is required",
  "code-required": "Code is required",
  "code-repeated": "The code already exists",
  "kind-tem": "Kind Template",
  "code": "Code",
  "deliver": "Deliver",
  "party": "Party",
  "property": "Property",
  "signer": "Signer",
  "name": "Name",
  "per": "Per",
  "transaction-type": "Transaction Type",
  "type": "Type",
  "workflow": "Workflow",
  "send": "Send",
  "title-delete-template": "Are you sure you want to delete the template?",
  "description-delete-template": "This action will permanently delete the template and cannot be undone. Are you sure you want to proceed?",
  "confirm-delete": "Yes, delete template",
  "deny-delete": "No, keep template",
  "search-documents": "Search Documents",
  "select-party": "Select a Party",
  "select-property": "Select a Property",
  "add-doc": "Add Documents",
  "select-doc": "Select all Documents",
  "description": "Description",
  "actions": "Actions",
  "upload": "Upload",
  "data": "Data",
  "document-download-success":"Document downloaded successfully.",
  "error-downloading":"An error occurred while downloading the file, please try again.",
  "lack-of-email":"We have an error,  one of the users doesn't have a valid email, please add a new one",
  "date": "Date",
  "signature-from": "Signature From",
  "notes": "Notes",
  "options": "Options",
  "status-pending": "Pending",
  "status-complete": "Complete",
  "status-declined": "Declined",
  "status-has-error": "Error",
  "kind": "Kind",
  "add-document": "Add Document",
  "tutorial": "Tutorial",
  "request-file": "Request File",
  "documents-updating-message": "The documents are updating, wait a few minutes and refresh the documents",
  "delete-document": "Delete Document",
  "delete-file": "Delete File",
  "lock": "Lock",
  "unlock": "Unlock",
  "lock-document": "Lock Document",
  "unlock-document": "Unlock Document",
  "available-files": "Available files",
  "included": "Included",
  "filter-by": "Filter by",
  "zip-content": "Zip Content",
  "pdf-content": "PDF Content",
  "available-properties": "Available Properties",
  "properties-in-document": "Properties in Document",
  "available-parties": "Available Parties",
  "deliver-to": "Deliver to",
  "parties-in-document": "Parties in Document",
  "document-signers": "Document Signers",
  "edit-content": "Edit content",
  "requestFileUploadTitle": "Request File Upload",
  "selectTheParty": "Select the party",
  "selectTheFiles": "Select the files",
  "sendRequest": "Send request",
  "includedParts": "Included parts",
  "pendingToUpload": "Pending to upload",
  "fileUploadInProgress": "File Upload in Progress",
  "fileUploadMessage": "Your file is being uploaded and will be processed in the background. It will appear in the system once processing is complete.",
  "ron": "(RON)",
  "lastUpdate": "Last update",
  "size": "Size",
  "viewFile": "View file",
  "download": "Download",
  "editTemplateData": "Edit template data",
  "requestSignature": "Request signature",
  "editArchive": "Edit Archive",
  "parties": "Parties",
  "expectedFrom": "Expected From",
  "deleteDocument": "Delete document",
  "editDocument": "Edit document",
  "reloadPageMessage": "Please reload the page in a little while to see the uploaded files.",
  "createFilePer": "Create file per",
  "createDocument": "Create Document",
  "createNewDocument": "Create New Document",
  "updateArchive": "Update Archive",
  "templateData": "Template Data",
  "uploadPartyFiles": "Upload Party Files",
  "uploads": "Uploads",
  "pdf": "PDF",
  "zip": "ZIP",
  "calcSpreadsheet": "Calc Spreadsheet",
  "drawDrawing": "Draw Drawing",
  "impressPresentation": "Impress Presentation",
  "writerDocument": "Writer Document",
  "add-party": "Add Party",
  "not-modified": "Not modified",
  "upload-files-tooltip": "Upload files",
  "add-parties-first-tooltip": "Before you upload files, first you need to add expected parties",
  "file-locked-tooltip": "This file won't be regenerated automatically when information changes.",
  "file-unlocked-tooltip": "This file will be regenerated automatically when information changes.",
  "filterBy": "Filter by"
}
